import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';


const theme = extendTheme({
  colors: {
    bmp: {
      'primary': "#7B3B56",
      'primary-hover': "#7B3B56CC",
      'secondary': "#7B603B",
      'complementary-1': "#7B403B",
      'complementary-2': "#9D524C",
      'complementary-3': "#3B767B",
      'complementary-4': "#567B3B",
      'complementary-5': "#603B7B",
      'text-color': "white",
      bg: "#6750a4",
    },
  },
});


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>

    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
